import { apiAgent, cachedGet } from './apiService';
import JwtUtils from '../utils/jwtUtils';

export const systemNotificationService = {
  async list({
    skip = 0,
    limit = 50,
    unreadOnly = false,
    notificationType = null,
    isRead = null,
    targetRole = null,
    bypassCache = false,
  } = {}) {
    const params = {
      skip,
      limit,
      unread_only: Boolean(unreadOnly),
    };
    if (notificationType) params.notification_type = notificationType;
    if (isRead !== null && isRead !== undefined) params.is_read = Boolean(isRead);
    if (targetRole) params.target_role = targetRole;

    // Trailing slash matches the backend route exactly (router prefix "/notifications" + "@router.get('/')").
    // Without it, FastAPI issues a 307 redirect to add the slash, and some mobile browsers drop the
    // Authorization header when following that redirect, causing a spurious 403 -> forced logout.
    return cachedGet('/notifications/', { params }, { ttlMs: 5000, bypassCache });
  },

  async count({ unreadOnly = false, notificationType = null, isRead = null, targetRole = null } = {}) {
    const params = { unread_only: Boolean(unreadOnly) };
    if (notificationType) params.notification_type = notificationType;
    if (isRead !== null && isRead !== undefined) params.is_read = Boolean(isRead);
    if (targetRole) params.target_role = targetRole;

    const res = await apiAgent.get('/notifications/count', { params });
    return res.data;
  },

  async unreadCount() {
    if (!JwtUtils.validateAndCleanToken()) {
      return { unread_count: 0 };
    }
    const res = await apiAgent.get('/notifications/unread-count');
    return res.data;
  },

  async markRead(notificationId) {
    const res = await apiAgent.patch(`/notifications/${notificationId}`, { is_read: true });
    return res.data;
  },

  async markAllRead() {
    const res = await apiAgent.post('/notifications/mark-all-read');
    return res.data;
  },

  async bulkMarkRead(ids = []) {
    const res = await apiAgent.post('/notifications/mark-read', { ids });
    return res.data;
  },

  async markSelectedRead(ids = []) {
    return this.bulkMarkRead(ids);
  },

  async delete(notificationId) {
    const res = await apiAgent.delete(`/notifications/${notificationId}`);
    return res.data;
  },
};

export default systemNotificationService;

